var _defs, _g, _g2, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgChat = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24.609,
    viewBox: "0 0 28 24.609",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon{fill:#95A1B2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.484 11.484)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M222.414,241H210.82a.82.82,0,0,0,0,1.641h11.594a.82.82,0,0,0,0-1.641Z",
    transform: "translate(-210 -241)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.484 14.766)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M217.492,301H210.82a.82.82,0,0,0,0,1.641h6.672a.82.82,0,1,0,0-1.641Z",
    transform: "translate(-210 -301)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M25.539,37.563H19.8v-4.1A2.464,2.464,0,0,0,17.336,31H2.461A2.464,2.464,0,0,0,0,33.461V43.3a2.464,2.464,0,0,0,2.461,2.461h.82v2.461a.82.82,0,0,0,1.275.683L8.2,46.478v3.389a2.464,2.464,0,0,0,2.461,2.461h8.064l4.715,3.143a.82.82,0,0,0,1.275-.683V52.328h.82A2.464,2.464,0,0,0,28,49.867V40.023A2.464,2.464,0,0,0,25.539,37.563ZM8.2,40.023v4.483L4.922,46.694V44.945a.82.82,0,0,0-.82-.82H2.461a.821.821,0,0,1-.82-.82V33.461a.821.821,0,0,1,.82-.82H17.336a.821.821,0,0,1,.82.82v4.1H10.664A2.464,2.464,0,0,0,8.2,40.023Zm18.156,9.844a.821.821,0,0,1-.82.82H23.9a.82.82,0,0,0-.82.82v1.748l-3.647-2.431a.82.82,0,0,0-.455-.138H10.664a.821.821,0,0,1-.82-.82V40.023a.821.821,0,0,1,.82-.82H25.539a.821.821,0,0,1,.82.82Z",
    transform: "translate(0 -31)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chat.345c9f0b.svg";
export { ForwardRef as ReactComponent };